import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

import { dispatcherFactory, selectorHookFactory } from '~/store/utils'

// Site selection shared across the chargeAI screens (Charging Optimization and
// Billing Cycles) so the chosen site is preserved when navigating between them.
export type ChargeAiSiteState = {
  selectedSiteId?: string
}

const initialState: ChargeAiSiteState = {}

const chargeAiSiteSlice = createSlice({
  name: 'chargeAiSite',
  initialState,
  reducers: {
    setSelectedSiteId(state, action: PayloadAction<string | undefined>) {
      state.selectedSiteId = action.payload
    }
  }
})

export default chargeAiSiteSlice.reducer

// Action creator for dispatching outside React (store setup, tests). The hook
// below wraps it for component use.
export const setChargeAiSiteId = chargeAiSiteSlice.actions.setSelectedSiteId

const selectSlice = (state: { chargeAiSite: ChargeAiSiteState }) => state.chargeAiSite

export const useChargeAiSiteId = selectorHookFactory((state) => selectSlice(state).selectedSiteId)
export const useSetChargeAiSiteId = dispatcherFactory(setChargeAiSiteId)
